<script lang="ts">
  // Rendered as an image so crawlers cannot harvest the e-mail address (regenerate with `vips text` when it changes).
  import emailImage from '../../../images/operator/email.png'
</script>

<img class="operator-email" src={emailImage} width="211" height="15" alt="" />

<style>
  .operator-email {
    display: block;
    margin: var(--space-3) 0 var(--space-7);
  }
</style>
